export default {
  goodsStatusEnum: {
    '-1': 'Nieopłacone',
    0: 'W trakcie weryfikacji',
    1: 'Oczekuje na potwierdzenie',
    2: 'Oczekuje na uzupełnienie',
    3: 'Zwrot towaru',
    4: 'Wymiana towaru',
    5: 'Wysłane przez sprzedawce',
    6: 'Osobna wysyłka',
    7: 'Odroczone przetwarzanie',
    8: 'Podpisano odbiór',
    9: 'W magazynie',
    10: 'Zmagazynowane',
    11: 'Zamówienie anulowane',
    12: 'Zniszczenie towaru',
    13: 'Zamówienie przeterminowane',
    14: 'Potwierdzenie informacji',
    15: 'Potwierdzenie zakupu',
    16: 'Oczekuje na zwrot',
    17: 'Oczekuje na wymianę',
    18: 'Przetwarzanie zwrotu',
    19: 'Przetwarzanie wymiany',
    20: 'Zwrot zakończony',
    21: 'Wymiana zakończona',
    22: 'Zakupione',
    23: 'W trakcie przetwarzania',
    24: 'Zamówienie anulowane',
    25: 'Zamówienie nieprawidłowe',
    26: 'Zwrot oczekuje na refundację',
    27: 'Wymiana oczekuje na wysyłkę od sprzedawcy',
    28: 'Wydane z magazynu',
    29: 'Wydane i spakowane',
    30: 'Wysłane za granicę',
    31: 'Otrzymano towar',
    32: 'Odmowa płatności za zamówienie',
    33: 'Kontrola ryzyka',
    34: 'Zwrot zrealizowany',
    35: 'Lista zamrożonych zamówień',
    36: 'Płatność przedsprzedażowa',
    37: 'Oczekuje na wysyłkę',
    38: 'Zwrot w toku',
    39: 'Odrzucone towary',
    40: 'Odrzucenie zakończone',
    41: 'Wyjątek - brak w magazynie',
    42: 'Wyjątek w magazynie',
    43: 'Anuluj zwrot',
    44: 'Anuluj wymianę',
    45: 'Podpisano i oczekuje',
    46: 'Przetwarzanie zamówień',
    47: 'Realizacja zamówienia',
    48: 'Płatność zakończona',
    49: 'Opuszczony',
    50: 'Obowiązkowe zakończenie',
    51: 'Oczekuje na zatwierdzenie zwrotu przez sprzedawcę',
    52: 'Oczekuje na zatwierdzenie wymiany przez sprzedawcę',
    53: 'Zwrócona paczka nieważna',
    54: '1688 oczekuje na wygenerowanie',
    55: '1688 oczekuje na płatność',
    56: 'Yino oczekuje na wygenerowanie',
    57: 'Yino oczekuje na płatność',
    58: 'Towary w transferze',
  },
  appendStatusEnum: {
    0: 'Oczekujące',
    1: 'W trakcie',
    2: 'Anulowane',
    3: 'Zakończony',
    4: 'Zwrócone',
  },
  inviteStatusEnum: {
    0: 'nieaktywny',
    1: 'Aktywowane',
  },
}
